import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import { BiDownload, BiPlus, BiTrash, BiXCircle } from "react-icons/bi";
import { SearchIcon } from '@primer/octicons-react';
import  DeleteConfirmDialog  from './DeleteConfirmDialog';
import { axiosAuth_BLDG_DATA_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';
import { formatFileSize } from '../utils/jsUtils';
import classes from './AdminPages.module.css';


const DocAdminListView = (props) => {

  const { t } = useTranslation(["common"]);

  const [docMgmtConfig,           setDocMgmtConfig]           = useState(null);

  const [errMsg,                  setErrMsg]                  = useState('');
  const [notFoundMsg,             setNotFoundMsg]             = useState('');

  const [deleteTarget,            setDeleteTarget]            = useState();
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);
  const [errMsgDeleteConfirm,     setErrMsgDeleteConfirm]     = useState('')

  const [searchTerms,             setSearchTerms]             = useState();


  // ----- Data Table stuff -----

  const [objList,   setObjList]   = useState([]);
  const [,          setLoading]   = useState(false);
  const [totalRows, setTotalRows] = useState();
  const [totalSize, setTotalSize] = useState();
  const [perPage,   setPerPage]   = useState(25);
  const [currPage,  setCurrPage]  = useState(1);
  const [sortCol,   setSortCol]   = useState(null);
  const [sortDir,   setSortDir]   = useState(null);

  const customStyles = {
    rows: {
      style: {
        minHeight: '25px', // override the row height
        fontSize: '11px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
  };

  const columns = [
    {
      name: t("I18N_Name"),
      sortable: true,
      sortField: 'name',
      grow: 2,
      cell: row => (
        <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleObjDetails(row)}>{row.name}</span>
      ),
    },
    {
      name: t("I18N_Display_name"),
      selector: row => row.displayName,
      grow: 2,
      wrap: true,
      sortable: true,
      sortField: 'displayName',
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Size"),
      selector: row => formatFileSize(row.size),
      grow: 0.5,
      right: true,
      wrap: true,
      sortable: true,
      sortField: 'size',
    },
    {
      name: t("I18N_Time_created"),
      selector: row =>formatDate(row.timeCreated),
      grow: 2,
      wrap: true,
      sortable: true,
      sortField: 'timeCreated',
    },
    {
      name: t("I18N_Time_updated"),
      selector: row =>formatDate(row.timeUpdated),
      grow: 2,
      wrap: true,
      sortable: true,
      sortField: 'timeUpdated',
    },
    {
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: row => (
        <>
          <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Download_doc")}</Tooltip>}>
            <span style={{marginLeft:'10px', verticalAlign:'top', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}}
                  onClick={event => handleDownloadDoc(row)}>
              <BiDownload size={12} />
            </span>
          </OverlayTrigger>
          { (row.ASSET_PHOTO_REF === 'FALSE') && (row.NO_ASSET_LINK_REF === 'FALSE') ?
              <OverlayTrigger overlay={<Tooltip id="tooltip-delete-app" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_entry")}</Tooltip>}>
                <span style={{marginLeft:'10px', cursor:'pointer', color:'SteelBlue'}}
                      onClick={() => handleObjDelete(row)}><BiTrash size={16} />
                </span>
              </OverlayTrigger>
            : null
          }
        </>
      )
    }
  ];


  const handlePageChange = currPage => {
    setCurrPage(currPage);
    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    currPage});

    fetchObjs(searchTerms, sortCol, sortDir, perPage, currPage);
  };


  const handlePerRowsChange = async (newPerPage) => {

    setPerPage(newPerPage);
    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     newPerPage,
                          currPage:    1});

    fetchObjs(searchTerms, sortCol, sortDir, newPerPage, 1);
  };


  const handleSort = (column, sortDir) => {

    // instead of setTimeout this is where you would handle your API call.
    setSortCol (column.sortField);
    setSortDir (sortDir);

    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     column.sortField,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});

    fetchObjs(searchTerms, column.sortField, sortDir, perPage, 1);
  };

  const paginationComponentOptions={
          rowsPerPageText: t("I18N_Rows_per_page"),
          rangeSeparatorText: t("I18N_Pagination_page_of_total"),
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: 'All'
        };

  // ----- END - Data Table stuff -----


  const onSearchInputChange = (e) => {
    setSearchTerms(e.target.value);
  }

  const handleSearchClear = ()  => {
    setSearchTerms('');

    setCurrPage(1); // Reset to page 1 for a fresh search
    props.onSetPageState({searchTerms: '',
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});

    fetchObjs('', sortCol, sortDir, perPage, 1);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    setCurrPage(1); // Reset to page 1 for a fresh search
    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});

    fetchObjs(searchTerms, sortCol, sortDir, perPage, 1);
  }


  // Initialize state
  useEffect(() => {

    setSearchTerms(props.pageState.searchTerms);
    setSortCol(props.pageState.sortCol);
    setSortDir(props.pageState.sortDir);
    setPerPage(props.pageState.perPage);
    setCurrPage(props.pageState.currPage);

    fetchObjs(props.pageState.searchTerms, props.pageState.sortCol, props.pageState.sortDir, props.pageState.perPage, props.pageState.currPage);

    fetchDocMgmtConfig();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const fetchObjs = async (searchTerms, sortCol, sortDir, perPage, currPage) => {

    try {
      setLoading(true);

      const res = await axiosAuth_DATA_MGMT_API.get("docs?searchTerms=" +
                                                    ((searchTerms && (searchTerms !== null)) ? encodeURIComponent(searchTerms) : '') +
                                                    ((sortCol     && (sortCol     !== null)) ? ("&sortColumn="  + sortCol + "&sortDirection=" + sortDir) : '')  +
                                                    ((perPage     && (perPage     !== null)) ? ("&limit="       + perPage)                               : '')  +
                                                    ((currPage    && (currPage    !== null)) ? ("&offset="      + (currPage - 1) * perPage)              : ''));

      if (res.data.data.length === 0) {
        setNotFoundMsg("I18N_No_search_result");
      } else {
        setNotFoundMsg('');
      }

      setObjList(res.data.data);

      setTotalRows(res.data.total);
      setTotalSize(res.data.totalSize);
      setLoading(false);
      setErrMsg('');
    } catch (error) {
      if (!error.message || (error.message !== 'IGNORE')) {
        setErrMsg(t(translateAPIError(error)));
      }
    }
  };


  const fetchDocMgmtConfig = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("business-configs?name=DOC_MANAGEMENT");

        resolve(res.data);

        if (res.status === 200) {
          setDocMgmtConfig(res.data[0].config);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  function handleObjDetails(obj) {
    props.onUIMode('DETAILS', obj);
  }


  // --- Doc Download ---

  function handleDownloadDoc(doc) {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_BLDG_DATA_API.get(`/files?path=${encodeURIComponent(doc.path)}`, {
                                                        responseType: "arraybuffer",
                                                      });

        resolve(res.data);

        if (res.status === 200) {

          // Convert HEX data to binary
          const blob = new Blob([new Uint8Array(res.data)], { type: doc.fileType });
          const blobUrl = URL.createObjectURL(blob);

          const nameSplit = doc.path.split("/");
          const fileName = nameSplit.pop();

          const link = document.createElement('a')

          link.href = blobUrl;
          link.download = "" + fileName + "";
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  // --- Obj delete ---

  function handleObjDelete(obj) {
    setDeleteTarget(obj);
    setShowDeleteConfirmDialog(true);
  }

  function handleObjDeleteCancel() {
    setDeleteTarget(null);
    setErrMsgDeleteConfirm('');
    setShowDeleteConfirmDialog(false);
  }

  function handleObjDeleteSubmit() {

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.delete("docs/" + deleteTarget.id);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsgDeleteConfirm('');
          setShowDeleteConfirmDialog(false);

          // This will also cause a reload of the list.  Change to page 1 because in case deleting
          // the last item on the last page, refreshing the old last page will cause error.
          handlePageChange(1);
        }

      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsgDeleteConfirm(t(translateAPIError(error)));
        }
      }

    });
  }


  // Create new user
  const handleNewObj = (e) => {
    e.preventDefault();
    props.onUIMode('NEW')
  }


  // ----- BEGIN UI -----

  return (
    <>
      <Card className='aaa' style={{border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)', padding:'20px 40px 20px 40px', maxWidth:'2500px', height:'850px', width:'100%'}}>
        <div style={{ display: 'flex' }}>
          <span className={classes.admin_pages__page_title}>
            {t("I18N_Doc_Mgmt")}
          </span>
          <span style={{marginLeft:'30px', marginTop:'7px', fontSize:'12px'}}>
            { docMgmtConfig && totalSize ?
                "(" + t("I18N_Doc_store_quota") + formatFileSize(docMgmtConfig.docStoreQuota * 1024.0) + "; " +
                t("I18N_Used") + formatFileSize(totalSize) + ", " + Number(100.0 * totalSize/(docMgmtConfig.docStoreQuota * 1024.0)).toFixed(1)  + "%)"
              : null
            }
          </span>
          <span style={{marginLeft:'auto', marginTop:'7px', color:'rgba(200,0,0)', fontSize:'12px'}}>
            {errMsg}
          </span>
          <div style={{ display: 'flex', marginLeft: '30px', marginRight: '0px', width: '250px', minWidth: '250px' }}>
            <OverlayTrigger overlay={<Tooltip id="tooltip-new_doc" style={{fontSize:'11px'}}>{t("I18N_TIP_New_doc")}</Tooltip>}>
              <span onClick={handleNewObj} style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                <BiPlus size={18} />
              </span>
            </OverlayTrigger>
            <span style={{ marginLeft: '20px', marginRight: '0px', width: '220px' }}>
              <Form onSubmit={handleSearchSubmit}>
                <Form.Group as={Row} >
                  <Col sm={9} style={{ marginRight: '5px' }}>
                    <div style={{ position: 'relative' }}>
                      <Form.Control style={{ fontSize: '12px' }} type="text" name="searchTerms" value={searchTerms}
                                    onChange={(e) => onSearchInputChange(e)} placeholder={t("I18N_Search_terms")} />
                      {searchTerms && <BiXCircle size={15}
                                         style={{position:'absolute', right:'10px', top: '50%', transform:'translateY(-50%)',
                                                 cursor:'pointer', color:'#aaa'}}
                                         onClick={handleSearchClear} />}
                    </div>
                  </Col>
                  <Col sm={2} style={{ padding: '5px' }}>
                    <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip-search" style={{fontSize:'11px'}}>{t("I18N_Search")}</Tooltip>}>
                      <span onClick={handleSearchSubmit} style={{ cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                        <SearchIcon size={18} />
                      </span>
                    </OverlayTrigger>
                  </Col>
                </Form.Group>
              </Form>
            </span>
          </div>
        </div>

        { (notFoundMsg && notFoundMsg !== '') ?
          <span className={classes.admin_pages__field_value} style={{marginTop:'20px'}}>
            {t(notFoundMsg)}
          </span>
        :
          <div style={{ overflowY:'auto', fontSize:'11px', marginTop:'10px' }}>

            { objList && objList.length > 0 ?
              <DataTable
                columns={columns}
                data={objList}
                customStyles={customStyles}
                fixedHeader
                fixedHeaderScrollHeight={'700px'}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationDefaultPage={currPage}
                paginationPerPage={perPage}
                paginationRowsPerPageOptions={[25,50,100]}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                onSort={handleSort}
                sortServer
                highlightOnHover
                paginationComponentOptions={paginationComponentOptions}
                noDataComponent={t("I18N_No_search_result")}
              />
            : null
            }

          </div>
        }

        <DeleteConfirmDialog
          title={t("I18N_Doc_del_confirm")}
          show={showDeleteConfirmDialog}
          targetName={deleteTarget ? deleteTarget.name : ''}
          errMsgDeleteConfirm={errMsgDeleteConfirm}
          onCancel={handleObjDeleteCancel}
          onSubmit={handleObjDeleteSubmit}
        />

      </Card>
    </>
  );
}


export default DocAdminListView;
